export default "__VITE_ASSET__DC3imtz6__"